import { render } from "./PlaybookDescriptionProjection.vue?vue&type=template&id=f9660c4c"
import script from "./PlaybookDescriptionProjection.vue?vue&type=script&lang=js"
export * from "./PlaybookDescriptionProjection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/PlaybookDescriptionProjection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9660c4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9660c4c', __exports__)) {
    api.reload('f9660c4c', __exports__)
  }
  
  module.hot.accept("./PlaybookDescriptionProjection.vue?vue&type=template&id=f9660c4c", () => {
    api.rerender('f9660c4c', render)
  })

}


export default __exports__